import styled from "styled-components";

export const CaseCentavrasWrapper = styled.div`
 
`



